import { fromClass } from "fw-model";

export class CommonAppIntegrationMetaData {
    AtsOrganizationMappingId: string;
}

export class CommonAppIntegration {
    Id: string;
    CommonAppYear: number;
    SdsUsername: string;
    SdsPassword: string;
    Enabled: boolean;

    @fromClass MetaData: CommonAppIntegrationMetaData;
}

export class CommonAppMappingException {
    OriginalFieldName: string;
    CorrectedFieldName: string;
}

export class CommonAppIntegrationArgs {
    CommonAppYear: number;
    SdsUsername: string;
    SdsPassword: string;
    Enabled: boolean;

    DataCatalog: File;
}
